// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".freshness[x-placement^=bottom][data-v-e810bc34]{background:var(--primary-500)!important;color:#fff;padding:.1rem .18rem;text-align:left!important;word-break:break-word!important}.freshness .popper__arrow[data-v-e810bc34],.freshness .popper__arrow[data-v-e810bc34]:after{border-bottom-color:var(--primary-500)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
